export class ActaModelData{
    id:number;
    id_validador:number;
    nombreDirectora:String;
    validador1:String;
    validador2:String;
    cedulaId1:String;
    cedulaId2:String;
    fechaInicioReal1:any;
    fechaFinReal1:any
    duracion1:String;
    fechaInicioReal2:any;
    fechaFinReal2:any
    duracion2:String;
    idJardinPeriodo:number;
    observaciones:String;
   
}